import Button, { ButtonVariants } from '@/components/atoms/Button/Button';
import { CheckAvailabilityButton } from '@/components/molecules/CheckAvailabilityButton';
import useWindowSize from '@/hooks/useWindowSize';
import { GOOGLE_TRACK_INFO } from '@/lib/constants';
import { DealerType } from '@/lib/schema/dealer/types';
import { FC } from 'react';

interface VDPCheckAvailabiltyCTABarProps {
  showCallModalButton: boolean;
  dealer?: DealerType | null;
  productId: string;
  setOpenCallModal: () => void;
  contactedDealer: boolean;
  backGroundImage: string;
  isAuthDialogOpen: boolean;
  setIsAuthDialogOpen: (isOpen: boolean) => void;
  messageDealer: () => Promise<void>;
  handleEmailNotification: () => Promise<void>;
}

export const VDPCheckAvailabiltyCTABar: FC<VDPCheckAvailabiltyCTABarProps> = ({
  showCallModalButton,
  dealer,
  productId,
  setOpenCallModal,
  contactedDealer,
  backGroundImage,
  isAuthDialogOpen,
  setIsAuthDialogOpen,
  messageDealer,
  handleEmailNotification,
}) => {
  const { isMobile } = useWindowSize();

  return (
    <div className="flex w-full justify-between gap-l p-xl ml:flex-col l:flex-row">
      {showCallModalButton && (
        <Button
          variant={ButtonVariants.Secondary}
          aria-label="call dealer"
          shadow={'shadow-ml m:shadow-none'}
          background={'bg-neutral-0'}
          analyticsEvent={{
            ...GOOGLE_TRACK_INFO.callDealerButton,
            pageTarget: dealer?.phone
              ? `/vehicle/${productId}?dealerPhone=${dealer.phone}`
              : `/vehicle/${productId}`,
          }}
          onClick={async () => {
            if (process.env.NEXT_PUBLIC_ENABLE_EMAIL_NOTIFICATION === 'true') {
              await handleEmailNotification();
            }
            if (isMobile) {
              window.open(`tel: ${dealer?.phone}`, '_self');
              return;
            }
            setOpenCallModal();
          }}
        >
          Call
        </Button>
      )}

      <CheckAvailabilityButton
        messageDealer={messageDealer}
        contactedDealer={contactedDealer}
        backGroundImage={backGroundImage}
        isAuthDialogOpen={isAuthDialogOpen}
        setIsAuthDialogOpen={setIsAuthDialogOpen}
        shadow={true}
        listingId={productId}
      />
    </div>
  );
};
